import { ReactNode } from "react";

import {
  Button,
  Displayer,
  RequiredAsterisk,
} from "@smart/itops-sb-design-system-dom";
import { ParagraphTag } from "@smart/itops-serialisation-basic";

import { sectionFallback, SectionItem } from "../../types";

export type SummarySectionProps = {
  section: SectionItem;
  onEdit?: () => void;
  children?: ReactNode;
  titleParagraphTag?: ParagraphTag;
};

export const SummarySection = ({
  section,
  onEdit,
  children,
  titleParagraphTag = "h2",
}: SummarySectionProps) => (
  <>
    <div className="border-[0.1rem] border-neutral-100 mb-[5.6rem]" />
    <section className="flex flex-col gap-small mb-[5.6rem]">
      <div className="flex flex-col gap-xSmall">
        <div className="flex justify-between items-start [&_h1]:text-h1 [&_h2]:text-h2 [&_h2]:font-poppins [&_h2]:font-semibold hyphens-auto">
          <Displayer
            paragraphTag={titleParagraphTag}
            value={section.title}
            fallback={sectionFallback}
          />
          {onEdit && (
            <Button
              className="mt-[0.3rem] min-w-[8.8rem]"
              text="Edit section"
              variant="highlight"
              size="small"
              onClick={onEdit}
            />
          )}
        </div>
        <div className="text-neutral-600">
          <RequiredAsterisk className="mx-0" /> Indicates required information
        </div>
      </div>
      <div className="flex flex-col gap-[5.6rem] mt-[5.6rem]">{children}</div>
    </section>
  </>
);
